import { domains, type environmentNames } from 'ui/config/constants';
import { getConfigString } from 'ui/util/getConfigString';

export interface ENVValues {
  app_env: environmentNames,
  app_url: string,
  api_url: string,
  api_token: string,
  stripe_kamino: string,
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getConfig = (allEnv: any) => {
  const env = allEnv.public as unknown as ENVValues;
  const config = {
    env: getConfigString('app_env', allEnv),
    appURL: domains[env.app_env].harmon,
    isLocal: env.app_env === 'local',
    isProd: env.app_env === 'production',
    domains: domains[getConfigString('app_env', allEnv) as environmentNames],
    stripe_kamino: getConfigString('stripe_kamino', allEnv),
    apiToken: getConfigString('api_token', allEnv),
    mediaURL: getConfigString('media_url', allEnv),
    title: 'Harmon',
    gMapsKey: getConfigString('g_maps_key', allEnv),
    nextURL: getConfigString('next_url', allEnv),
  };
  return config;
};
